<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៣.ក ៣.ខ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <prematenv :denv="cla_env" :dmate="mate" :title="title[1]" />
            <preintoy :data="mat_toy" :title="title[2]" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import preMatEnv from "@/components/privateascf/sharedCom/compreMatEnviron.vue";
import preInternalToy from "@/components/ascf/pre/preInternalToy.vue";
export default {
  props: ["title", "cla_env", "mate", "mat_toy"],
  components: {
    prematenv: preMatEnv,
    preintoy: preInternalToy,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>